/* src/app/shared/components/paperless-commercial-invoice/components/paperless-commercial-invoice-terms-dialog/paperless-commercial-invoice-terms-dialog.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.dialog-message {
  margin: 1em 0;
}
.terms-title {
  font-weight: 700;
  margin-bottom: 0.5em;
}
.terms-message {
  width: 100%;
  height: 270px;
  background-color: #f4f4f4;
  border: solid thin #dddbdc;
  overflow: scroll;
  padding: 1em;
  color: #817b7b;
  font-size: 0.9em;
}
.terms-agreement {
  font-size: 0.9em;
  margin: 1rem;
}
.dialog-title {
  padding: 2rem 2.5rem 0.725rem;
}
.mat-mdc-dialog-content {
  padding: 0 2.5rem;
}
.mat-mdc-dialog-actions {
  padding: 8px;
  margin-bottom: 0;
  font-size: 0.8em;
}
@media screen and (min-width: 48rem) {
  .mat-mdc-dialog-actions {
    padding: 2.5rem;
  }
}
.mat-mdc-dialog-actions a {
  padding: 0 1em;
  text-decoration: none;
  line-height: 1;
}
.mat-mdc-dialog-actions a.cancel {
  color: #817b7b;
}
.mat-mdc-dialog-actions a:not(:last-of-type) {
  border-right: solid thin #817b7b;
}
.mat-mdc-dialog-actions button:last-of-type {
  margin-left: 0;
}
@media screen and (min-width: 48rem) {
  .mat-mdc-dialog-actions button:last-of-type {
    margin-left: 3em;
  }
}
/*# sourceMappingURL=paperless-commercial-invoice-terms-dialog.component.css.map */
